// extracted by css-extract-rspack-plugin
export default {"checkbox":"HeaderCheckbox_checkbox__6IVqF"};